import React, { FC } from "react";
import { List } from "semantic-ui-react";

// ShowError Component
/**
 * This component is used to display an error for the user to verify their information
 * or an error if there is no data.
 */

const ShowError: FC = () => (
    <div className="col-xs-12 max-w-500 center-content full-width m-b-spacer-3xl">
        <List className="p-t-spacer-xl p-b-spacer-lg ">
            <List.Item className="m-b-spacer-lg">
                <List.Content>
                    <p className="text-center">
                        There was an error with you request, please try again.
                    </p>
                </List.Content>
            </List.Item>
        </List>
    </div>
);

export default ShowError;
